(function () {
  'use strict';

  // Visually hidden live region — screen readers announce its text changes politely
  var liveRegion = document.createElement('div');
  liveRegion.setAttribute('role', 'status');
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.setAttribute('aria-atomic', 'true');
  // Visually hidden: clip-path (modern) + 1px clip fallback; avoid legacy clip:rect(0,0,0,0)
  liveRegion.style.cssText =
    'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;' +
    'clip:rect(1px,1px,1px,1px);clip-path:inset(50%);white-space:nowrap;border:0;word-wrap:normal';
  document.body.appendChild(liveRegion);

  // Foundation fires 'down.zf.accordion' (open) and 'up.zf.accordion' (close)
  // on the accordion <ul>. We catch both at the document level.
  document.addEventListener('down.zf.accordion', function (evt) {
    update(evt.target, true);
  });

  document.addEventListener('up.zf.accordion', function (evt) {
    update(evt.target, false);
  });

  // Sync aria-expanded when accordions open via deep link / initial Foundation state
  function syncAccordionAriaFromDom() {
    document.querySelectorAll('.accordion a.accordion-title').forEach(function (trigger) {
      var item = trigger.closest('.accordion-item');
      if (!item) return;
      var isOpen = item.classList.contains('is-active');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAccordionAriaFromDom);
  } else {
    syncAccordionAriaFromDom();
  }

  function update(panel, isOpen) {
    var item = panel && panel.closest('.accordion-item');
    var trigger = item && item.querySelector('a.accordion-title');
    if (!trigger) return;

    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    var label = (trigger.querySelector('strong') || trigger).textContent.trim();
    liveRegion.textContent = '';
    setTimeout(function () {
      liveRegion.textContent = label + (isOpen ? ', expanded' : ', collapsed');
    }, 50);
  }
})();
